import { render } from "./DataplantCreationFullscreen.vue?vue&type=template&id=216c2a06&lang=pug"
import script from "./DataplantCreationFullscreen.vue?vue&type=script&lang=js"
export * from "./DataplantCreationFullscreen.vue?vue&type=script&lang=js"

import "./DataplantCreationFullscreen.vue?vue&type=style&index=0&id=216c2a06&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__